
import { AllGalleryView } from './all/AllGalleryView'

import { PersonaSwitcher } from '../../../components/PersonaSwitcher';

// --- Profile Component ---

const Gallery = () =>
    <PersonaSwitcher
        adminView={<AllGalleryView />}
        teacherView={<AllGalleryView />}
    />

export { Gallery };
